<template>
  <b-form-group
    label="Notlar"
    label-for="notes"
  >
    <b-form-textarea
      id="notes"
      v-model="dataItem.notes"
      placeholder="Notlar"
    />
    <div
      class="font-small-3 text-muted font-italic"
      style="margin-top: 4px"
    >
      Ürün fiyatı hakkında opsiyonel not bilgisi
    </div>
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormTextarea,
} from 'bootstrap-vue'

export default {
  name: 'NotesCard',
  components: {
    BFormGroup,
    BFormTextarea,
  },
  computed: {
    dataItem() {
      return this.$store.getters['productPrices/dataItem']
    },
  },
}
</script>
